import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconSend: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4394 2.56037C16.8544 1.97537 16.026 1.74537 15.221 1.94621L4.29367 4.67788C2.837 5.04205 1.86523 6.29537 1.87607 7.79703C1.8869 9.2987 2.87534 10.5379 4.337 10.882L8.20867 11.7929L9.11952 15.6637C9.46368 17.1254 10.7028 18.1137 12.2044 18.1245C12.2119 18.1245 12.2203 18.1245 12.2278 18.1245C13.7187 18.1245 14.9602 17.1554 15.3227 15.707L18.0545 4.77953C18.2545 3.97537 18.0253 3.1462 17.4394 2.56037ZM16.8411 4.47621L14.1093 15.4037C13.8352 16.4979 12.9511 16.8812 12.212 16.8745C11.5078 16.8695 10.5945 16.4745 10.3361 15.3779L9.41615 11.4687L12.9419 7.94204C13.1861 7.69788 13.1861 7.30204 12.9419 7.05787C12.6978 6.81371 12.3019 6.81371 12.0577 7.05787L8.53114 10.5845L4.62183 9.66453C3.52433 9.4062 3.12944 8.49205 3.12444 7.78788C3.11944 7.08371 3.50185 6.16371 4.59518 5.89037L15.5227 3.15869C15.6119 3.13619 15.7019 3.12538 15.7902 3.12538C16.0736 3.12538 16.3469 3.23704 16.5544 3.44454C16.8269 3.71621 16.9344 4.10205 16.8411 4.47621Z"
      fill={color}
    />
  </svg>
);

export default IconSend;
